import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Separator } from 'components/common/Separator/Separator'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Back from 'components/common/Back'

const GoBack = ({ handleGoBack }) =>
  <GoBackWrapper>
    <Back data-at-comfirmtiresize-goback handler={ handleGoBack }>Back</Back>
    <GoBackSeparator />
  </GoBackWrapper>

GoBack.propTypes = {
  handleGoBack: PropTypes.func
}

export default GoBack

const GoBackWrapper = styled.div`
  ${Media.mobile`
    margin-left: 30px;
  `}
`

const GoBackSeparator = styled(Separator)`
  ${Mixin.responsive('margin', '25px 0 50px', '25px 0 22px;')}
`
